import useStore from "../../store/store";
import styles from '../../style.module.scss'
import Hint from "../ui/hint/hint";
const SummaryHead = () => {
    const summaryHead = useStore((state) => state.summaryHead)
    if (!!summaryHead) {
        if (!!summaryHead?.needAuth){
            return (
                <a href={'/cp/'} className={`${styles.needAuth} p-small-size`} target={'_blank'}>
                    {summaryHead?.message || 'Войдите в аккаунт'}
                </a>
            );
        } else {
            return (
                <div className={`${styles.head} status-head-${summaryHead?.cardStatus}`}>
                    <div className={styles.label}>Ваш статус</div>
                    <div className={styles.status}>
                        {summaryHead.cardName}
                        {
                            !!summaryHead?.cardText && (<Hint text={summaryHead.cardText} fill={'#fff'}/>)
                        }
                    </div>
                </div>
            );
        }
    }
    return null;
};

export default SummaryHead;